<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/forum">Forum</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Detail</li>
        </ol>
      </div>
    </nav>

    <LoadedComponent :loading="loading" />

    <div class="container" v-if="!loading">
      <AlertComponent :message="successMessage" :alert-type="'success'" />

      <div class="text-center">
        <h2 class="title">{{ forum.name }}</h2>
        <p>{{ forum.description }}</p>
      </div>

      <hr />

      <div class="product-details product-details-centered product-details-separator">
        <button type="button" class="btn btn-primary btn-sm mr-2" data-toggle="modal" data-target="#forum-edit-modal"
          v-if="permission.update_forum">
          <i class="las la-edit"></i>
        </button>

        <button type="button" class="btn btn-danger btn-sm" data-toggle="modal" data-target="#delete-forum-confirm"
          v-if="permission.delete_forum">
          <i class="las la-trash-alt"></i>
        </button>
      </div>





      <div class="mt-4 mb-4" v-if="!loading">
        <div class="alert alert-success mb-2" v-if="successMessageComment">
          <h5 style="color: white; text-align: center; font-family: sans-serif">
            {{ successMessageComment }}
          </h5>
        </div>

        <div class="alert alert-danger" v-if="errorMessageComment">
          <h5 style="color: white; text-align: center; font-family: sans-serif">
            {{ errorMessageComment }}
          </h5>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="product-details-tab">
              <ul class="nav nav-pills justify-content-center" role="tablist">
                <li class="nav-item">
                  <a class="nav-link" id="product-shipping-link" data-toggle="tab" href="#product-shipping-tab"
                    role="tab" aria-controls="product-shipping-tab" aria-selected="false">Test e sondaggi ( {{
                      forum.count_test
                    }} )
                  </a>
                </li>
                <li class="nav-item active">
                  <a class="nav-link" id="product-review-link" data-toggle="tab" href="#product-review-tab" role="tab"
                    aria-controls="product-review-tab" aria-selected="false">Commenti ({{ forum.count_comment }})</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="card-body">
            <div class="tab-content">
              <div class="tab-pane fade" id="product-shipping-tab" role="tabpanel"
                aria-labelledby="product-shipping-link">
                <div class="product-desc-content">
                  <div id="testcomponent">
                    <!-- Componente per i test -->
                    <TestComponent :activity_id_params="forum?.id"></TestComponent>
                  </div>
                </div>
                <!-- End .product-desc-content -->
              </div>
              <div class="tab-pane fade show active" id="product-review-tab" role="tabpanel"
                aria-labelledby="product-review-link">

                <div class="reviews">
                  <CommentFormComponent :activity_id="forum.id" :successmessagecomment="successMessageComment"
                    @setSuccessMessage="setSuccessMessage" :errormessagecomment="errorMessageComment"
                    @setErrorMessage="setErrorMessage" :loadComments="loadComments"
                    :comment_permission="comment_permission">
                  </CommentFormComponent>
                </div>

                <CommentListComponent :activity_id="forum.id" :successmessagecomment="successMessageComment"
                  @setSuccessMessage="setSuccessMessage" :comments="comments" :loadComments="loadComments"
                  :comment_permission="comment_permission"></CommentListComponent>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="forum-edit-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-forum-update">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>

            <div class="form-box">
              <div class="form-tab">
                <ul class="nav nav-pills nav-fill" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link" id="signin-tab" data-toggle="tab" href="#signin" role="tab"
                      aria-controls="signin" aria-selected="true">Aggiorna discussione</a>
                  </li>
                </ul>
                <div class="tab-content" id="tab-content-5">
                  <div class="tab-pane fade show active" id="signin" role="tabpanel" aria-labelledby="signin-tab">
                    <form @submit.prevent="sendUpdateForum">
                      <div class="form-group">
                        <label for="title-forum">Titolo discussione</label>
                        <input type="text" class="form-control" id="title-forum" name="nome" v-model="form.name"
                          placeholder="Scrivi il titolo della discussione" />
                      </div>
                      <!-- End .form-group -->
                      <div class="alert alert-danger" v-if="errors.name">
                        {{ errors.name[0] }}
                      </div>

                      <div class="form-group">
                        <label for="description-forum">Messaggio</label>
                        <textarea class="form-control" id="description-forum" name="descrizione"
                          v-model="form.description" placeholder="Descrivi la discussione "></textarea>
                      </div>
                      <!-- End .form-group -->
                      <div class="alert alert-danger" v-if="errors.description">
                        {{ errors.description[0] }}
                      </div>

                      <div class="form-footer">
                        <button type="submit" class="btn btn-outline-primary-2 btn-order btn-block">
                          <span class="btn-text">Invia</span>
                          <span class="btn-hover-text">Aggiorna la discussione</span>
                        </button>
                      </div>
                      <!-- End .form-footer -->
                    </form>
                  </div>
                  <!-- .End .tab-pane -->
                </div>
                <!-- End .tab-content -->
              </div>
              <!-- End .form-tab -->
            </div>
            <!-- End .form-box -->
          </div>
          <!-- End .modal-body -->
        </div>
        <!-- End .modal-content -->
      </div>
      <!-- End .modal-dialog -->
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="delete-forum-confirm">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Elimina la discussione</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-forum">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="m-4">
              <p>Sei sicuro/a di voler eliminare la discussione?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="close" id="delete-modal-close" data-dismiss="modal" aria-label="Close">
              Annulla
            </button>
            <button type="button" class="btn btn-outline-primary" @click="deleteForum">
              Elimina
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import httpservices from "@/services/httpservices.js";
import router from "@/router";
import CommentFormComponent from "@/components/CommentForm.vue";
import CommentListComponent from "@/components/CommentList.vue";
import AlertComponent from "@/components/AlertComponent.vue";
import TestComponent from "@/components/TestComponent.vue";
export default {
  name: "ForumDetailPage",
  props: ["slug"],
  model: {
    prop: "comments",
  },
  components: {
    LoadedComponent,
    CommentFormComponent,
    CommentListComponent,
    AlertComponent,
    TestComponent
  },

  data() {
    return {
      successMessage: "",
      forum: {},
      successMessageComment: "",
      errorMessageComment: "",
      comments: [],
      loading: false,
      comment_permission: false,
      permission: {},
      form: {
        name: "",
        id: "",
        description: "",
      },
      errors: [],
    };
  },
  mounted() {
    //TODO: Bug nella ricerca dei permessi
    this.loadPermission();
    this.loadForum();
  },
  methods: {
    async loadPermission() {
      await httpservices
        .checkPermission(0, "comments", "create_comment")
        .then((response) => {
          this.comment_permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
      await httpservices
        .checkPermission(1, "forum", "")
        .then((response) => {
          this.permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async sendUpdateForum() {
      await httpauth
        .post("/forum/update", this.form)
        .then((response) => {
          this.successMessageComment = response.data.message;

          document.getElementById("close-modal-forum-update").click();
          router.push("/forum/" + response.data.slug);
        })
        .catch((error) => {
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
    async deleteForum() {
      await httpauth
        .get("/forum/delete/" + this.forum.slug)
        .then((response) => {
          document.getElementById("close-modal-delete-forum").click();
          localStorage.setItem("messageSuccessForum", response.data.message);
          router.push("/forum");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async loadForum() {
      try
      {
        const response = await httpauth.get("/forum/show/" + this.slug);
        this.forum = response.data.data;
        this.form.id = this.forum.id;
        this.form.name = this.forum.name;
        this.form.description = this.forum.description;

        this.permission = response.data.permission;
        this.loadComments();
      } catch (error)
      {
        if (
          error.response &&
          error.response.status === 401 &&
          error.response.data.message === "Unauthenticated."
        )
        {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        }
      }
    },
    updateComments(newComments) {
      // Emit an event to update the prop value outside the component
      this.$emit("update:comments", newComments);
    },
    setSuccessMessage(value) {
      this.successMessageComment = value;
    },
    setErrorMessage(value) {
      this.errorMessageComment = value;
    },
    async loadComments() {
      try
      {
        const response = await httpservices.loadComments(this.forum.id);
        this.comments = response.data.data;
        this.loading = false;
      } catch (error)
      {
        console.log(error);
      }
    },
  },
};
</script>